import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {}

  successToastr(message: string): void {
    this.toastr.success(this.translateService.instant(message));
  }

  errToastr(message: string): void {
    this.toastr.error(this.translateService.instant(message));
  }

  infoToastr(message: string): void {
    this.toastr.info(this.translateService.instant(message));
  }
}
